/**
 * @function to capitalize the first letter of a string or each word in the string
 * @param {string} str - The input string to be capitalized
 * @param {boolean} capitalizeWords - If true, capitalize the first letter of each word; otherwise, capitalize the first letter of the string
 */

export function capitalizeString(str, capitalizeWords = false) {
    if (capitalizeWords) {
        return str
            .split(' ') // Split the string into words
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(' '); // Join the words back into a string
    }
    else {
        // Capitalize only the first letter of the entire string
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
}